import 'taos';

const MODULE = document.querySelectorAll('[data-module="header"]');

class Header {
    constructor() {
        this.components = MODULE;
        this.fontScale = 1;
        this.minScale = 0.8;
        this.maxScale = 1.4;
        this.step = 0.1;
        this.scrollThreshold = 150;
        this.lastScrollY = window.scrollY || 0;
        this.init();
    }

    init() {
        const isDark = sessionStorage.getItem('darkMode') === 'true';
        document.documentElement.classList.toggle('dark', isDark);

        const storedScale = parseFloat(sessionStorage.getItem('fontScale')) || 1;
        this.fontScale = Math.min(this.maxScale, Math.max(this.minScale, storedScale));
        document.documentElement.style.setProperty('font-size', `${this.fontScale}em`);

        this.components.forEach((component) => {
            const darkModeBtn = component.querySelectorAll('.dark-mode-toggle');
            const isDark = sessionStorage.getItem('darkMode') === 'true';

            if (isDark) {
                document.documentElement.classList.add('dark');
                darkModeBtn.forEach(el => {
                    el.classList.add('dark');
                });
            }

            if (darkModeBtn) {
                darkModeBtn.forEach(el => {
                    el.addEventListener('click', () => {
                        const active = document.documentElement.classList.toggle('dark');
                        el.classList.toggle('dark', active);
                        sessionStorage.setItem('darkMode', active);
                    });
                })
            }

            const increaseBtn = component.querySelectorAll('.aumentar-texto');
            const decreaseBtn = component.querySelectorAll('.diminuir-texto');

            if (increaseBtn) {
                increaseBtn.forEach((button) => {
                    button.addEventListener('click', () => this.adjustFont(true));
                })
            }

            if (decreaseBtn) {
                decreaseBtn.forEach((button) => {
                    button.addEventListener('click', () => this.adjustFont(false));
                })
            }

            const menuMobileBtn = component.querySelector('.btn-menu-mobile');
            const menuMobileContent = component.querySelector('.menu-mobile-content')

            if (menuMobileBtn) {
                menuMobileBtn.addEventListener('click', () => this.menuMobile(menuMobileContent))
            }

            const btnGoTop = document.querySelector('.go-top');
            btnGoTop.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                });
            })
        });

        this.handleScroll();
        window.addEventListener('scroll', () => this.handleScroll());
    }

    adjustFont(increase = true) {
        const newScale = this.fontScale + (increase ? this.step : -this.step);
        this.fontScale = Math.min(this.maxScale, Math.max(this.minScale, newScale));
        document.documentElement.style.setProperty('font-size', `${this.fontScale}em`);
        sessionStorage.setItem('fontScale', this.fontScale.toFixed(2));
    }

    handleScroll() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;

        this.components.forEach((component) => {
            if (scrollTop > this.scrollThreshold) {
                component.classList.add('is-scrolled');
            } else {
                component.classList.remove('is-scrolled');
            }

            const direction = scrollTop > this.lastScrollY ? 'down' : 'up';
            component.setAttribute('data-scroll-direction', direction);
        });

        this.lastScrollY = scrollTop;
    }

    menuMobile(menuMobileContent) {
        menuMobileContent.classList.toggle('is-open');
        menuMobileContent.closest('header').classList.toggle('is-menu-open');
        document.body.classList.toggle('block-scroll');
    }
}

(() => {
    if (MODULE.length) {
        new Header();
    }
})();

export default Header;
